import { useEffect } from 'react';
import { useRouting } from '@rad/hooks/useRouting';
import { useAuth } from '../../hooks/useAuth';
import { pathToURL } from './urls/_';
export const pathToRoute = (path) => {
    return pathToURL(path);
};
export const createRedirect = (config) => {
    return () => {
        const [, navigate] = useRouting();
        const [auth] = useAuth();
        useEffect(() => {
            const route = config.check(config.getRoutes(), auth.hasPermission);
            navigate(route ? pathToRoute(route.path) : pathToRoute(config.fallback));
        }, [auth, navigate]);
        return null;
    };
};
